import { AstNodeCategory, AstNodeType } from './node';
export class IfExpression {
    constructor(token, condition, consequence, alternative) {
        this.token = token;
        this.condition = condition;
        this.consequence = consequence;
        this.alternative = alternative;
        this.nodeType = AstNodeType.IfExpression;
        this.nodeCategory = AstNodeCategory.Expression;
    }
    get Condition() {
        return this.condition;
    }
    set Condition(val) {
        this.condition = val;
    }
    get Consequence() {
        return this.consequence;
    }
    set Consequence(val) {
        this.consequence = val;
    }
    get Alternative() {
        return this.alternative;
    }
    set Alternative(val) {
        this.alternative = val;
    }
    tokenLiteral() {
        return this.token.literal;
    }
    toString() {
        let str = `if
        ${this.condition.toString()}
        ${this.consequence.toString()}
        `;
        if (this.alternative) {
            str += `else ${this.alternative.toString()}`;
        }
        return str;
    }
}
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiSWZFeHByZXNzaW9uLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vLi4vLi4vc3JjL2xpYi9hc3QvSWZFeHByZXNzaW9uLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUdBLE9BQU8sRUFBRSxlQUFlLEVBQUUsV0FBVyxFQUFjLE1BQU0sUUFBUSxDQUFDO0FBRWxFLE1BQU0sT0FBTyxZQUFZO0lBQ3JCLFlBQ1ksS0FBWSxFQUNaLFNBQXNCLEVBQ3RCLFdBQTRCLEVBQzVCLFdBQTRCO1FBSDVCLFVBQUssR0FBTCxLQUFLLENBQU87UUFDWixjQUFTLEdBQVQsU0FBUyxDQUFhO1FBQ3RCLGdCQUFXLEdBQVgsV0FBVyxDQUFpQjtRQUM1QixnQkFBVyxHQUFYLFdBQVcsQ0FBaUI7UUFHeEMsYUFBUSxHQUFnQixXQUFXLENBQUMsWUFBWSxDQUFDO1FBQ2pELGlCQUFZLEdBQW9CLGVBQWUsQ0FBQyxVQUFVLENBQUM7SUFIeEQsQ0FBQztJQUtKLElBQUksU0FBUztRQUNULE9BQU8sSUFBSSxDQUFDLFNBQVMsQ0FBQztJQUMxQixDQUFDO0lBRUQsSUFBSSxTQUFTLENBQUMsR0FBRztRQUNiLElBQUksQ0FBQyxTQUFTLEdBQUcsR0FBRyxDQUFDO0lBQ3pCLENBQUM7SUFFRCxJQUFJLFdBQVc7UUFDWCxPQUFPLElBQUksQ0FBQyxXQUFXLENBQUM7SUFDNUIsQ0FBQztJQUVELElBQUksV0FBVyxDQUFDLEdBQUc7UUFDZixJQUFJLENBQUMsV0FBVyxHQUFHLEdBQUcsQ0FBQztJQUMzQixDQUFDO0lBRUQsSUFBSSxXQUFXO1FBQ1gsT0FBTyxJQUFJLENBQUMsV0FBVyxDQUFDO0lBQzVCLENBQUM7SUFFRCxJQUFJLFdBQVcsQ0FBQyxHQUFHO1FBQ2YsSUFBSSxDQUFDLFdBQVcsR0FBRyxHQUFHLENBQUM7SUFDM0IsQ0FBQztJQUVELFlBQVk7UUFDUixPQUFPLElBQUksQ0FBQyxLQUFLLENBQUMsT0FBTyxDQUFDO0lBQzlCLENBQUM7SUFFRCxRQUFRO1FBQ0osSUFBSSxHQUFHLEdBQUc7VUFDUCxJQUFJLENBQUMsU0FBd0IsQ0FBQyxRQUFRLEVBQUU7VUFDeEMsSUFBSSxDQUFDLFdBQThCLENBQUMsUUFBUSxFQUFFO1NBQ2hELENBQUM7UUFFRixJQUFJLElBQUksQ0FBQyxXQUFXLEVBQUU7WUFDbEIsR0FBRyxJQUFJLFFBQVEsSUFBSSxDQUFDLFdBQVcsQ0FBQyxRQUFRLEVBQUUsRUFBRSxDQUFDO1NBQ2hEO1FBRUQsT0FBTyxHQUFHLENBQUM7SUFDZixDQUFDO0NBQ0oifQ==